import { Link } from "react-router-dom";

const STEPS = [
  {
    title: "Connect a mailbox",
    body: "Sign in with Google or Microsoft (read-only access), or add any IMAP mailbox with an app password. Choose how much history to import.",
  },
  {
    title: "AI reads every likely receipt",
    body: "The background worker checks your inbox every few minutes. Emails that look financial (or carry a PDF or image) are read by the AI model, which extracts the vendor, amount, tax, dates, invoice number and card, then classifies the document as paid, owed or income.",
  },
  {
    title: "Review and send to QuickBooks",
    body: "Receipts appear in your dashboard with the original email and attachments. Fix anything by hand, then push to QuickBooks Online, or turn on auto-sync and let it happen automatically.",
  },
];

export default function HowItWorks() {
  return (
    <div className="how-page">
      <div className="section-eyebrow">How it works</div>
      <h1 className="section-heading">From inbox to ledger in three steps</h1>
      <p className="section-lead" style={{ marginBottom: 0 }}>
        Connect once, review what the AI captured, and keep QuickBooks current without manual entry.
      </p>

      <div className="steps">
        {STEPS.map((step, i) => (
          <div key={step.title} className="step">
            <div className="step-num">{i + 1}</div>
            <div className="step-body">
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: 40 }}>
        <Link to="/register" className="btn btn-primary btn-lg">Get started</Link>
      </div>
    </div>
  );
}
